// src/main.ts
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import {
  reportStaleChunkError,
  startAppUpdateMonitor,
  stopAppUpdateMonitor
} from './composables/useAppUpdate'

// CoreUI
import CoreuiVue from '@coreui/vue'
import '@coreui/coreui/dist/css/coreui.min.css'
import { CIcon } from '@coreui/icons-vue'
import * as iconSet from '@coreui/icons'

// Vue Router
import router from './router/index'

import './assets/main.css'

const app = createApp(App)

app.use(createPinia())          // ✅ Install Pinia
app.use(CoreuiVue)              // ✅ Install CoreUI globally
app.use(router)                 // ✅ Install Vue Router
app.component('CIcon', CIcon)   // ✅ Register CIcon globally
app.provide('icons', iconSet)   // ✅ Provide all icons for CIcon

router.onError((error) => {
  reportStaleChunkError(error)
})

const onUnhandledRejection = (event: PromiseRejectionEvent) => {
  reportStaleChunkError(event.reason)
}
window.addEventListener('unhandledrejection', onUnhandledRejection)

void startAppUpdateMonitor()

window.addEventListener('beforeunload', () => {
  window.removeEventListener('unhandledrejection', onUnhandledRejection)
  stopAppUpdateMonitor()
})

app.mount('#app')               // ✅ Mount the app
